import { ISiteBuilderState } from 'core-components/sitebuilder/store/models/ISiteBuilderState'

let store: any

export const setSiteBuilderAppStore = (applicationStore: any) => (store = applicationStore)
export const siteBuilderGetState = (): ISiteBuilderState => store.getState().siteBuilder

export const setSiteBuilderNextState = <T>({ payload, type }: { payload: T; type: string }) => {
  store.dispatch({ payload, type })
}
